import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import {
  ChannelDelete,
  GetScheduleList,
  SetActiveInactiveChanel,
  ViewChannelList,
} from "../../../api/api";
import "../../../assets/css/style.scss";
import deleteIcon from "../../../assets/images/DeleteIcon.svg";
import editIcon from "../../../assets/images/EditIcon.svg";
import sortingIcon from "../../../assets/images/sortIcon.svg";
import video_icon from "../../../assets/images/video-icon.png";
import viewIcon from "../../../assets/images/ViewIcon.svg";
import icroundsearch from "../../../assets/svg/Assetmanagemant/search.svg";
import AddIcon from "../../../assets/svg/Distribution/AddIcon.svg";
import Loader from "../../../component/Loader/Loader";
import ErrorPopup from "../../../component/popup/ErrorPopup";
import { cloudFront_URL } from "../../../service/API_URL";
import { permissionDetails } from "../../../utility/localStoageData";
import NextButton from "../../Common/NextButton";
import PrevButton from "../../Common/PrevButton";
import SearchBar from "../../search-bar/searchBar";
import "./channelSetupNew.scss";
import Pagination from "../../Common/Pagination";

function ChannelSetupNew() {
  const [channelList, setChannelList] = useState([]);
  const [showLoader, setshowLoader] = useState(true);
  const [sortColumn, setSortColumn] = useState("name");
  const [sortDirection, setSortDirection] = useState("asc");
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageJump, setPageJump] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [numberOfElement, setNumberOfElement] = useState(0);
  const [errorbox, setErrorbox] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [btntext, setbtntext] = useState(null);
  const [eventdelete, seteventdelete] = useState(null);
  const [permission, setpermission] = useState(null);
  const [scheduleList, setScheduleList] = useState([]);
  const locationState = useLocation();
  const navigate = useNavigate();

  const deletepopup = (event, id) => {
    event.stopPropagation();
    setbtntext("Delete");
    setErrorMessage("Do you want to delete ?");
    setErrorbox(true);
    seteventdelete(() => () => deleteChannel(id));
  };

  const errorboxclose = () => {
    setErrorbox(false);
    setErrorMessage("");
  };

  const getPermission = () => {
    let findEdit = permissionDetails();
    if (findEdit.includes("CHANNEL_SETUP_EDIT")) setpermission("edit");
    else if (findEdit.includes("CHANNEL_SETUP_READ")) setpermission("read");
    else setpermission(null);
  };

  useEffect(() => {
    getPermission();
    fetchSchedule();
  }, []);

  const fetchSchedule = async () => {
    let queryParams = {
      sortBy: sortColumn,
      sortOrder: sortDirection,
      pageNumber: currentPage,
      pageSize: 99999,
      daysList: 7,
    };
    let scheduleData = await GetScheduleList(queryParams);
    setScheduleList(scheduleData?.data?.content);
  };

  useEffect(() => {
    let queryParams = {
      searchText: searchText,
      sortBy: sortColumn,
      sortOrder: sortDirection,
      pageNumber: locationState?.state?.currentPage
        ? locationState?.state?.currentPage
        : currentPage,
      pageSize: pageSize,
    };
    getChannelList(queryParams);
  }, [currentPage]);

  const goToCreateChannel = () => {
    navigate("/channelCreation");
  };
  async function handlePageSize(value) {
    let val = value.target.value
    setPageSize(val);
    let queryParams = {
      searchText: searchText,
      sortBy: "name",
      sortOrder: "asc",
      pageNumber: currentPage,
      pageSize: val,
    };
    await getChannelList(queryParams);
  }
  const handleSorting = (column) => {
    let sorting = {
      sortColumn: column,
      sortDirection: null,
    };
    setSortColumn(column);
    if (sortDirection === "asc") {
      setSortDirection("desc");
      sorting.sortDirection = "desc";
    } else {
      setSortDirection("asc");
      sorting.sortDirection = "asc";
    }

    let queryParams = {
      searchText: searchText,
      sortBy: sorting.sortColumn,
      sortOrder: sorting.sortDirection,
      pageNumber: currentPage,
      pageSize: pageSize,
    };
    getChannelList(queryParams);
  };

  const getChannelList = async (queryParam) => {
    const channelResponse = await ViewChannelList(setshowLoader, queryParam);
    if (channelResponse?.content && channelResponse?.content?.length) {
      let channelList = channelResponse?.content.map((item) => {
        return { ...item, activeProgress: false };
      });
      setChannelList(channelList);
      setCurrentPage(channelResponse?.number);
      setTotalPages(channelResponse?.totalPages);
      setNumberOfElement(channelResponse?.totalElements);
      setPageSize(channelResponse?.size);
    } else {
      setChannelList([]);
    }
    navigate(locationState.pathname, { state: {} });
  };

  const deleteChannel = async (param) => {
    const response = await ChannelDelete(param);
    if (response?.data?.message === "Channel deleted successfully") {
      toast.success(response.data.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      let queryParams = {
        searchText: "",
        sortBy: sortColumn,
        sortOrder: sortDirection,
        pageNumber: currentPage,
        pageSize: pageSize,
      };
      getChannelList(queryParams);
    } else {
      toast.error("Channel Deletion failed", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
    }
  };

  const handleChannelStatus = async (event, channel) => {
    const inProgressTableData = channelList.map((row) =>
      row.id === channel ? { ...row, activeProgress: true } : row
    );
    setChannelList(inProgressTableData);
    let res = await SetActiveInactiveChanel(
      channel,
      event.target.value === "true" ? false : true
    );
    if (res?.status) {
      const updatedTableData = channelList.map((row) =>
        row.id === channel
          ? {
              ...row,
              activeProgress: false,
              active: event.target.value === "true" ? false : true,
            }
          : row
      );

      setChannelList(updatedTableData);
      toast.success(res?.data?.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
    } else {
      toast.error(res?.response?.data?.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 3000,
      });
      setChannelList(channelList);
    }
  };

  const handleSearch = (event) => {
    setSearchText(event);
    let queryParams = {
      searchText: event.length === 0 ? "" : event,
      sortBy: sortColumn,
      sortOrder: sortDirection,
      pageNumber: 0,
      pageSize: pageSize,
    };
    if (event.length >= 3 || event.length < 1) getChannelList(queryParams);
  };

  const editChannel = (event) => {
    navigate("/channelCreation", {
      state: {
        id: event,
        permission: permission,
        currentPage: currentPage,
      },
    });
  };

  const handleNext = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const setPage = (e) => {
    if (e.target.value > 0 && e.target.value <= totalPages) {
      setPageJump(e.target.value - 1);
    }
  };
  const handleKeyPress = (event) => {
    event.preventDefault();
    setCurrentPage(pageJump);
  };

  const handleRowClick = (itemId) => {
    navigate("/channelDetails", {
      state: {
        id: itemId,
        permission: permission,
        currentPage: currentPage,
      },
    });
  };

  return permission !== null ? (
    <div className="content-body dark">
      <div className="dashboard-content dark">
        <div className="top-content">
          <div className="left-side">
            <h3>Channel Management</h3>
          </div>
          <div className="right-side addbuttonBox">
            <SearchBar
              placeholder="Search by channel name"
              searchValue={searchText}
              searchOutput={handleSearch}
              keyEnter={false}
              icon={icroundsearch}
            />
            {permission === "edit" && (
              <button className="add-channel-btn" onClick={goToCreateChannel}>
                <img src={AddIcon} alt="Add Icon" className="add-icon-dist" />
                Add
              </button>
            )}
          </div>
        </div>

        <div className="channel-setup-table">
          <table className="cms-table-list channel-table">
            <thead>
              <tr>
                <th
                  className="col1"
                  onClick={() => {
                    handleSorting("name");
                  }}
                ></th>
                <th
                  className="col2 "
                  onClick={() => {
                    handleSorting("name");
                  }}
                >
                  <label>Channel Name</label>
                  <span>
                    <img
                      src={sortingIcon}
                      alt="img"
                      style={{ marginLeft: "5px" }}
                    />
                  </span>
                </th>
                <th className="col3">
                  <label>Partner Name</label>
                </th>
                <th
                  className="col4"
                  onClick={() => {
                    handleSorting("type");
                  }}
                >
                  <label>Channel type</label>
                  <span>
                    <img
                      src={sortingIcon}
                      alt="img"
                      style={{ marginLeft: "5px" }}
                    />
                  </span>
                </th>
                <th className="col5">
                  <label>Category</label>
                </th>
                <th className="col6">
                  <label>Action</label>
                </th>
                <th className="col7"></th>
              </tr>
            </thead>

            <tbody>
              {showLoader ? (
                <tr style={{ height: "80px" }}>
                  <td colSpan="7">
                    <div className="tableLoader">
                      <Loader />
                    </div>
                  </td>
                </tr>
              ) : channelList.length !== 0 ? (
                channelList.map((item, index) => (
                  <tr key={index} onClick={() => handleRowClick(item.id)}>
                    <td className="col1">
                      {item?.channelLogo[0]?.thumbnailSourcePath ? (
                        <div
                          style={{
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                          }}
                        >
                          <img
                            className="mx-2"
                            style={{
                              display: "block",
                              maxHeight: "36px",
                              maxWidth: "60px",
                              backgroundSize: "contain",
                            }}
                            src={
                              cloudFront_URL +
                              item?.channelLogo[0]?.thumbnailSourcePath
                            }
                            alt=""
                          />
                        </div>
                      ) : (
                        <div
                          style={{
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                          }}
                        >
                          <img
                            className="mx-2"
                            style={{
                              display: "block",
                              maxHeight: "28px",
                              maxWidth: "60px",
                              backgroundSize: "contain",
                            }}
                            src={video_icon}
                            alt="img"
                          />
                        </div>
                      )}
                    </td>
                    <td className="col2">{item.name}</td>
                    <td className="col3">
                      {item.partners.map((partner, index) => {
                        if (index > 0) {
                          return <span key={index}>, {partner.name}</span>;
                        } else {
                          return <span key={index}>{partner.name}</span>;
                        }
                      })}
                    </td>
                    <td className="col4">{item.type}</td>
                    <td className="col5">
                      {item.categories.map((category, index) => {
                        if (index > 0) {
                          return <span key={index}>, {category.name}</span>;
                        } else {
                          return <span key={index}>{category.name}</span>;
                        }
                      })}
                    </td>
                    <td className="col6">
                      <div className="table-action-group channel-action-group">
                        <div
                          className="switch-check"
                          onClick={(e) => e.stopPropagation()}
                        >
                          {item.activeProgress ? (
                            <span className="switch-loader"></span>
                          ) : null}
                          {permission === "edit" ? (
                            <>
                              <input
                                type="checkbox"
                                checked={item.active}
                                value={item.active}
                                onChange={(event) => {
                                  event.stopPropagation();
                                  handleChannelStatus(event, item.id);
                                }}
                                id={item.id}
                                onClick={(e) => e.stopPropagation()}
                              />
                              <label
                                htmlFor={item.id}
                                onClick={(e) => e.stopPropagation()}
                              ></label>
                            </>
                          ) : permission === "read" ? (
                            <>
                              <input
                                type="checkbox"
                                checked={item.active}
                                value={item.active}
                                disabled
                                id={item.id}
                                onClick={(e) => e.stopPropagation()}
                              />
                              <label
                                htmlFor={item.id}
                                onClick={(e) => e.stopPropagation()}
                              ></label>
                            </>
                          ) : null}
                        </div>
                      </div>
                    </td>
                    <td className="col7">
                      {" "}
                      <div className="action-icons-group">
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRowClick(item.id);
                          }}
                        >
                          <img src={viewIcon} alt="view" />
                        </div>
                        {
                            permission === "edit" &&
                            <div
                            onClick={(e) => {
                                e.stopPropagation();
                                editChannel(item.id);
                            }}
                            >
                            <img src={editIcon} alt="edit" />
                            </div>
                        }
                        {
                            permission === "edit" &&
                            <div
                            onClick={(e) => {
                                e.stopPropagation();
                                deletepopup(e, item.id);
                            }}
                            >
                            <img src={deleteIcon} alt="delete" />
                            </div>
                        }
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="text-center" colSpan="7">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {!showLoader && channelList.length > 0 ? (
            <Pagination
              currentPage={currentPage}
              pageSize={pageSize}
              numberOfElement={numberOfElement}
              handlePrev={handlePrev}
              handleKeyPress={handleKeyPress}
              setPage={setPage}
              totalPages={totalPages}
              handleNext={handleNext}
              handlePageSize={handlePageSize}
            />
          ) : null}
        </div>

        <ToastContainer />
        {errorbox && (
          <ErrorPopup
            btntext={btntext}
            message={errorMessage}
            closebox={() => errorboxclose()}
            overrides={() => eventdelete()}
          />
        )}
      </div>
    </div>
  ) : (
    ""
  );
}

export default ChannelSetupNew;
